// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1UACk","tab":"Tabs_tab__1urNW","tabActive":"Tabs_tabActive__3kgSP"};